module.exports = __webpack_public_path__ + "img/smoke.eb752a5d.svg";